(function () {
  // Guard: run only when executed from a section script tag
  const script = document.currentScript;
  const sectionRoot = script ? script.closest('[data-section]') : document;
  if (!sectionRoot) return;

  const sectionId = sectionRoot.getAttribute('data-section') || 'pdp';
  window.__pdpBuyNowObserver = window.__pdpBuyNowObserver || {};
  if (window.__pdpBuyNowObserver[sectionId]) return; // already installed for this section

  function getVar(name) {
    try {
      return getComputedStyle(sectionRoot).getPropertyValue(name).trim() || null;
    } catch (e) {
      return null;
    }
  }

  function applyToElement(el) {
    if (!el || el.nodeType !== 1) return;
    const y = getVar('--pdp-btn-padding-y');
    const x = getVar('--pdp-btn-padding-x');
    const f = getVar('--pdp-btn-font-size');
    const r = getVar('--pdp-button-radius');

    if (f) el.style.fontSize = f;
    if (y && x) el.style.padding = `${y} ${x}`;
    else if (y) el.style.padding = `${y} ${x || '3rem'}`;
    if (r) el.style.borderRadius = r;
    if (y) el.style.minHeight = `calc(${y} * 2 + 1em)`;

    // Ensure centering/layout
    el.style.display = 'inline-flex';
    el.style.alignItems = 'center';
    el.style.justifyContent = 'center';
    el.style.textAlign = 'center';
  }

  function applyAll() {
    const wrapper = sectionRoot.querySelector('.shopify-payment-button');
    if (!wrapper) return;

    // If provider renders an iframe inside the wrapper, style the wrapper only
    const iframe = wrapper.querySelector('iframe');
    if (iframe) {
      const y = getVar('--pdp-btn-padding-y');
      const x = getVar('--pdp-btn-padding-x');
      const f = getVar('--pdp-btn-font-size');
      const r = getVar('--pdp-button-radius');
      if (f) wrapper.style.fontSize = f;
      if (y && x) wrapper.style.padding = `${y} ${x}`;
      if (r) wrapper.style.borderRadius = r;
      if (y) wrapper.style.minHeight = `calc(${y} * 2 + 1em)`;
      return;
    }

    // Apply to inner clickable elements
    const candidates = wrapper.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__button--unbranded, [role="button"], button');
    candidates.forEach((el) => applyToElement(el));

    // If the section provided a custom buy-now label, apply it to visible payment buttons
    try {
      var productFormEl = sectionRoot.querySelector('product-form');
      var buyNowLabel = productFormEl && productFormEl.dataset ? productFormEl.dataset.buyNowLabel : null;
      if (buyNowLabel) {
        var buttonCandidates = wrapper.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__button--unbranded, [role="button"], button');
        buttonCandidates.forEach(function (el) {
          if (!el) return;
          // don't touch iframes
          if (el.querySelector && el.querySelector('iframe')) return;
          // avoid overriding icon-only buttons
          var onlyIcon = el.children.length === 1 && (el.querySelector('svg') || el.querySelector('img'));
          if (onlyIcon) return;
          var inner = el.querySelector('span') || el;
          try { inner.textContent = buyNowLabel; } catch (e) {}
          try { el.setAttribute('aria-label', buyNowLabel); } catch (e) {}
        });
      }
    } catch (e) {
      // defensive: don't break styling if anything fails
    }

    // Also ensure any immediate span used for visible text is centered
    const spans = wrapper.querySelectorAll('span');
    spans.forEach((s) => {
      // apply styles to parent clickable element if present
      const parentBtn = s.closest('.shopify-payment-button__button, [role="button"], button');
      if (parentBtn) return; // already styled
      applyToElement(s);
    });
  }

  // initial apply
  applyAll();

  // debounce helper
  let t;
  const observer = new MutationObserver((mutations) => {
    if (t) clearTimeout(t);
    t = setTimeout(() => {
      applyAll();
    }, 50);
  });

  observer.observe(sectionRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

  window.__pdpBuyNowObserver[sectionId] = observer;

  // Cleanup: disconnect observer if section removed (Theme Editor re-renders)
  const cleanup = new MutationObserver(() => {
    if (!document.body.contains(sectionRoot)) {
      if (window.__pdpBuyNowObserver && window.__pdpBuyNowObserver[sectionId]) {
        try { window.__pdpBuyNowObserver[sectionId].disconnect(); } catch (e) {}
        delete window.__pdpBuyNowObserver[sectionId];
      }
      try { cleanup.disconnect(); } catch (e) {}
    }
  });

  cleanup.observe(document.body, { childList: true, subtree: true });
})();
